import { ErrorAlertProviderV2 } from "./ErrorAlertProviderV2";
import { useErrorAlertV2 } from "./useErrorAlertV2";

export { useErrorAlertV2, ErrorAlertProviderV2 };
